import React, { Component } from 'react';
import MaterialTable from 'material-table';
import AutorenewIcon from '@material-ui/icons/Autorenew';

export class ListofAllProjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //projectList: [{ name: 'Proje 1', id: 1 }, { name: 'Proje 2', id: 2 }],
            projectList: [],
        };
    }

    componentDidMount = async () => {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        let pageData = { operation: "GetListOfProjects" };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ projectList: result.projects });
            });
    };

    render() {
        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    columns={[
                        { title: 'Project Id', field: 'idProjectDetails', hidden: true },
                        { title: 'Project Name', field: 'ProjectTitle' },
                        { title: 'Project Number', field: 'ProjectNumber' },
                    ]}
                    data={this.state.projectList}
                    title="Projects"
                    actions={[
                        {
                            icon: 'info',
                            tooltip: 'Project Details',
                            onClick: (event, rowData) => {
                                this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                            },
                        },
                        //{
                        //    icon: 'info',
                        //    tooltip: 'Project Monitoring',
                        //    onClick: (event, rowData) => {
                        //        this.props.history.push(`/cycleofthereport/${rowData.idProjectDetails}`);
                        //    },
                        //},
                        {
                            icon: 'info',
                            tooltip: 'Mission List',
                            onClick: (event, rowData) => {
                                this.props.history.push(`/missionlist/${rowData.idProjectDetails}`);
                            },
                        },
                    ]}
                    options={{
                        actionsColumnIndex: -1
                    }}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/ListofAllProjects.js